import { Flex } from '@chakra-ui/react';

import { Button, Text } from 'ui';

interface LocationButtonChangeProps {
  locationName: string;
  onLocatioStep: () => void;
  isSingleLocation: boolean;
}
const LocationButtonChange = ({
  locationName,
  onLocatioStep,
  isSingleLocation = false
}: LocationButtonChangeProps) => (
  <Flex
    align='center'
    w='100%'
    gap={{ base: '23px', md: '50px', lg: '71px' }}
    bg='black'
    py='13.5px'
    px={['12px', '15px', '20px']}
    borderTopRadius={{ base: 0, sm: '4px' }}
    flexWrap={{ base: 'wrap', md: 'nowrap' }}
    width={{ base: 'calc(100% + 30px)', sm: '100%' }}
    mx={{ base: '-15px', sm: '0' }}
  >
    <Flex
      alignItems={{ base: 'center' }}
      justifyContent={{ base: 'flex-start' }}
      w={{ base: '100%', md: '200px' }}
      gap='16px'
    >
      <Text color='white' fontSize='18px'>
        {locationName}
      </Text>
      {!isSingleLocation && (
        <Button
          onClick={onLocatioStep}
          variant='text'
          fontSize='11px'
          textTransform='uppercase'
          textDecoration='underline'
          color='white'
          w='auto'
          px={0}
          py='3px'
          minHeight='20px'
          height='auto'
        >
          Change
        </Button>
      )}
    </Flex>
  </Flex>
);

export default LocationButtonChange;
